<template>
    <div class="padding-20">
        <div
                v-show="errorMessage"
                class="alert alert-danger"
                role="alert"
        >
            {{ errorMessage }}
        </div>
        <div
                v-show="successMessage"
                class="alert alert-success"
                role="alert"
        >
            {{ successMessage }}
        </div>
        <SpinnerLoader v-show="loading"></SpinnerLoader>
    </div>
</template>

<script>
    import SpinnerLoader from "../components/common/SpinnerLoader";
    import {activateUser} from "../api";
    import i18n from '../i18n'

    export default {
        title: "Activate User",
        name: "ActivateUser",
        components: {SpinnerLoader},
        data: () => {
            return {
                loading: false,
                errorMessage: "",
                successMessage: ""
            }
        },
        async mounted() {
            let uidb64 = this.$route.params.uidb64;
            let token = this.$route.params.token;

            try {
                await activateUser(uidb64,token);
                this.loading = false;
                this.successMessage = i18n.t('views.activate_user.success_activate');
            } catch (e) {
                this.loading = false;
                if (e.response.data.code === "user_already_activated") {
                    this.successMessage = i18n.t('views.activate_user.already_activate');
                } else {
                    this.errorMessage = i18n.t('views.activate_user.error_generic');
                }
                console.log(e)
            }

        }
    }
</script>
